import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Client from './client';
import { PATH } from '#/guest-aps/config';
import { ERROR_CODES } from '#/guest-aps/config';
import { useParkinglotMetadataSaveStorage } from '#/guest-aps/hooks/use-parkinglot-metadata-save-storage';
import type { UseQueryOptions } from '@tanstack/react-query';

export const usePoi = (
  { poiId }: { poiId: string },
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof Client.fetchPoiById>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const navigate = useNavigate();
  const { data, status, error } = useQuery({
    queryKey: ['poi', poiId],
    queryFn: () => Client.fetchPoiById({ poiId }),
    refetchInterval: false,
    enabled: !!poiId,
    ...options,
  });

  const parkinglot = data?.data?.data ?? null;

  useParkinglotMetadataSaveStorage(parkinglot);

  useEffect(() => {
    if (status === 'error')
      navigate(`${PATH.ERROR}?code=${ERROR_CODES.NO_EXIST}`);
  }, [status, navigate]);

  return {
    parkinglot,
    getPoiStatus: status,
    getPoiError: error,
  };
};
